import { ServiceMaker } from ".";
import { OtpTypes } from "../utils/otp";

export const generateRegistrationOTP = (data: {
  type: OtpTypes;
  userContact: number;
}) => ServiceMaker("otp/generate/registration", "POST", data);
